import React, { Fragment } from 'react';
import { Select, MenuItem } from '@mui/material';
import { getGenericFieldType } from '../utils/genericUtils';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import ColorConstants from '../../../defaults/ColorConstants';

const theme = createTheme({
  overrides: {
  },
});

const useStyles = makeStyles({
  root: {
    "&:hover": {
      borderLeft: `4px solid ${ColorConstants.BlueAlien} !important`,
    }
  },
});

export default function FieldChooser({selectedField, fields, onChange}) {
  const classes = useStyles();
  const handleOnChange = field => {
    const selectedItem = fields.filter(x => x.name === field.target.value);
    if(selectedItem.length > 0){
      onChange(selectedItem[0]);
    } else {
      onChange("");
    }
  };

const getFieldChooser = () =>
{
  return (fields.length > 1 ) ?
    (
      <ThemeProvider theme={theme}>
        <Select
          fullWidth
          style={{ whiteSpace: 'nowrap', width: 300, padding: '0 5px' }}
          value={selectedField && selectedField.name}
          onChange={handleOnChange}
          placeholder="Select Field..."
          MenuProps={{
              sx: {
                "&& .Mui-selected": {
                  borderLeft: `4px solid ${ColorConstants.BlueAlien} !important`
                },
              }
            }}
        >
          {getOptions(fields)}
        </Select>
      </ThemeProvider>
    )
    :
    (
      <label>{selectedField.alias}</label>
    );
}
  const getFieldType = esriFieldType => {
    const shortFieldType = getGenericFieldType(esriFieldType);

    return (
      shortFieldType.charAt(0).toUpperCase() +
      shortFieldType.substr(1).toLowerCase()
    );
  };

  const getOptions = fields => {
    return fields.map(field => {
      return (
        <MenuItem
          value={field.name}
          key={field.name}
          title={field.name}
          subtitle={getFieldType(field.type)}
          classes={{root: classes.root, selected: classes.selected}} 
          style={{ display: 'block', padding: 5, borderLeft: `4px solid ${ColorConstants.WhiteAlien}`}}
        >
          {field.alias || field.name}
        </MenuItem>
      );
    });
  };

  return (
      <Fragment>
      {getFieldChooser()}
      </Fragment>
  );
}